import gql from "graphql-tag";

const getSessionInformation = gql`
  query sessionInformation {
    sessionInformation {
      user {
        id
        version
        groups {
          id
          name
          version
        }
        contact {
          id
          firstName
          middleName
          lastName
          photoId
          emails {
            id
            address
          }
        }
        permissions {
          actions
          object
        }
      }
      currentBusiness {
        id
        contact {
          id
          companyName
          photoId
        }
        offices {
          id
          status
          contact {
            id
            companyName
            alias
            photoId
          }
        }
      }
      currentOffice {
        id
        contact {
          id
          companyName
          alias
          photoId
        }
      }
    }
  }
`;

const switchBusinessMutation = gql`
  mutation(
    $businessId: String
  ) {
    switchBusiness (
      businessId: $businessId
    ) {
      id
      contact {
        id
        companyName
        alias
        photoId
      }
    }
  }
`;

const switchOfficeMutation = gql`
  mutation(
    $officeId: String
  ) {
    switchOffice (
      officeId: $officeId
    ) {
      id
      contact {
        id
        companyName
        alias
        photoId
      }
    }
  }
`;

export {
  getSessionInformation,
  switchBusinessMutation,
  switchOfficeMutation
};
